import { html, css, LitElement } from 'lit-element';
import { LinkStyles } from '../styles/link-styles';
import { withRouting } from './route-base';

export class RoutedLink extends withRouting()(LitElement) {
    static get styles() {
        return [LinkStyles.styles];
    }

    render() {
        const url = this.buildUrl();
        if (url) {
            return html`
                <a href=${url}>
                    <slot></slot>
                </a>
            `;
        }
        return html` <slot></slot> `;
    }
}

window.customElements.define('routed-link', RoutedLink);
